/* eslint-disable no-nested-ternary */
import { Tag } from '@components';
import { useScreenSize } from '@hooks';
import CourseCardGradient from '@pngs/CoursesPage/CourseCardGradient.png';
import { Flex, theme, Typography } from '@styles';
import { bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';

import { courseCardLayoutByVariant } from './CourseCard.layoutProps';

const CourseCard = ({
  completedLessonsCount,
  cover,
  description,
  handleNavigate,
  isCoursesPage,
  isLoggedIn,
  materials,
  peoplePassed,
  test,
  time,
  title,
  totalLessonsCount,
}) => {
  const { device, isTabletLG } = useScreenSize();

  const layout = courseCardLayoutByVariant[device || 'desktop'];

  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={device === 'desktop' ? 40 : 24}
      maxHeight={layout.maxHeight}
      maxWidth={isCoursesPage ? (isTabletLG ? '100%' : '33%') : layout.maxWidth}
      minHeight={600}
      onClick={isLoggedIn && handleNavigate}
      pointer
      {...(isCoursesPage && { position: 'relative' })}
    >
      <Flex
        backgroundImage={cover}
        backgroundSize="cover"
        flex={1}
        flexDirection="column"
      >
        <Flex
          backgroundImage={CourseCardGradient}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          flex={1}
          flexDirection="column"
          p={16}
        >
          <Flex
            bottom="16px"
            flexDirection="column"
            gap={10}
            mt={isTabletLG || !isCoursesPage ? 'auto' : 0}
            {...(!isTabletLG && isCoursesPage && { position: 'absolute' })}
          >
            <Flex flexWrap="wrap" gap={8} width="100%">
              <Tag content={time} variant="time" />
              {materials && <Tag content={materials} variant="material" />}
              {test && <Tag content={test} variant="test" />}
              {peoplePassed && (
                <Tag content={peoplePassed} variant="peoplePassed" />
              )}
            </Flex>
            <Typography
              color={theme.colors.white[100]}
              mt={14}
              variant="BN-bold-s43-lh38"
            >
              {title}
            </Typography>
            {description && (
              <Typography
                color={theme.colors.white[60]}
                textOverflow="ellipsis"
                variant="MS-regular-s14-lh22"
              >
                {description}
              </Typography>
            )}
          </Flex>
        </Flex>
      </Flex>
      {!isCoursesPage &&
        (totalLessonsCount > 0 ? (
          <Flex margin="0px 10px">
            {Array.from(
              { length: totalLessonsCount },
              (_, index) => index + 1
            ).map((el) => (
              <Flex
                background={
                  el <= completedLessonsCount
                    ? theme.colors.schoolBusYellow[100]
                    : theme.colors.white[100]
                }
                height="8px"
                marginRight="4px"
                opacity="0.2"
                width={`${(1 / totalLessonsCount) * 100}%`}
              />
            ))}
          </Flex>
        ) : (
          <Flex height="8px" />
        ))}
    </Flex>
  );
};

CourseCard.propTypes = {
  completedLessonsCount: number,
  cover: string.isRequired,
  description: string,
  handleNavigate: func.isRequired,
  isCoursesPage: bool,
  isLoggedIn: bool.isRequired,
  materials: oneOfType([number, string]).isRequired,
  peoplePassed: oneOfType([number, string]),
  test: string,
  time: oneOfType([number, string]).isRequired,
  title: string.isRequired,
  totalLessonsCount: number,
};

CourseCard.defaultProps = {
  completedLessonsCount: 0,
  description: null,
  isCoursesPage: false,
  peoplePassed: null,
  test: null,
  totalLessonsCount: 0,
};

export default CourseCard;
